import { render, staticRenderFns } from "./ghac3.vue?vue&type=template&id=445ce68d&scoped=true&"
import script from "./ghac3.vue?vue&type=script&lang=js&"
export * from "./ghac3.vue?vue&type=script&lang=js&"
import style0 from "./ghac3.vue?vue&type=style&index=0&id=445ce68d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445ce68d",
  null
  
)

export default component.exports